import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShareDialog({ sessionId, users: providedUsers, userEmail, children }) {
  const [users, setUsers] = useState(providedUsers || []);
  const [loading, setLoading] = useState(false);

  const handleOpenChange = async (open) => {
    if (!open || providedUsers) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API}/users`);
      setUsers(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      toast.error("Impossible de charger les utilisateurs");
    } finally {
      setLoading(false);
    }
  };

  const visibleUsers = users.filter(
    (user) => user.email?.toLowerCase() !== userEmail?.toLowerCase()
  );

  const handleShare = async (userId) => {
    try {
      await axios.post(`${API}/share`, { session_id: sessionId, user_id: userId });
      toast.success("Dossier partagé");
    } catch (error) {
      toast.error("Erreur lors du partage");
    }
  };

  return (
    <Dialog onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent onClick={(event) => event.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>Partager avec</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          {visibleUsers.map((user) => (
            <Button
              key={user.id}
              variant="outline"
              className="w-full justify-start"
              onClick={() => handleShare(user.id)}
            >
              {user.name} ({user.email})
            </Button>
          ))}
          {loading && (
            <p className="text-sm text-muted-foreground">Chargement…</p>
          )}
          {!loading && visibleUsers.length === 0 && (
            <p className="text-sm text-muted-foreground">Aucun utilisateur disponible.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
